import { render, staticRenderFns } from "./IncomesSection.vue?vue&type=template&id=4d1ce47e&"
import script from "./IncomesSection.vue?vue&type=script&lang=js&"
export * from "./IncomesSection.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports